import {SummaryType} from '../competitors-page-type';

import {StatisticsCardTemplateItemType} from './statistics-cards-type';

export const statisticsTemplate: Array<StatisticsCardTemplateItemType> = [
    {
        langKey: 'REVIEWS_ANALYSIS__COMPETITORS__STATISTICS__AVERAGE_POSITION',
        formatOptions: {},
        isInvertColor: true,
        getValueAndDelta: (
            data?: SummaryType
        ): {
            value: SummaryType['avgPosition']['current'] | null;
            delta: SummaryType['avgPosition']['delta'] | null;
        } => ({value: data?.avgPosition.current || null, delta: data?.avgPosition.delta || null}),
    },
    {
        langKey: 'REVIEWS_ANALYSIS__COMPETITORS__STATISTICS__CARD_IMPROVMENT',
        formatOptions: {},
        isInvertColor: false,
        getValueAndDelta: (
            data?: SummaryType
        ): {
            value: SummaryType['cardsImprovedPosition'] | null;
            delta: null;
        } => ({value: data?.cardsImprovedPosition || null, delta: null}),
    },
    {
        langKey: 'REVIEWS_ANALYSIS__COMPETITORS__STATISTICS__CARD_WORSENING',
        formatOptions: {},
        isInvertColor: false,
        getValueAndDelta: (
            data?: SummaryType
        ): {
            value: SummaryType['cardsWorsenedPosition'] | null;
            delta: null;
        } => ({
            value: data?.cardsWorsenedPosition || null,
            delta: null,
        }),
    },
    {
        langKey: 'REVIEWS_ANALYSIS__COMPETITORS__STATISTICS__GROWTH_POTENTIAL',
        formatOptions: {},
        isInvertColor: false,
        getValueAndDelta: (
            data?: SummaryType
        ): {
            value: SummaryType['potentialGrowthImpressions']['current'] | null;
            delta: SummaryType['potentialGrowthImpressions']['delta'] | null;
        } => ({
            value: data?.potentialGrowthImpressions.current || null,
            delta: data?.potentialGrowthImpressions.delta || null,
        }),
    },
    {
        langKey: 'REVIEWS_ANALYSIS__COMPETITORS__STATISTICS__GROWTH_POTENTIAL_CALLS',
        formatOptions: {
            maximumFractionDigits: 0,
        },
        isInvertColor: true,
        getValueAndDelta: (
            data?: SummaryType
        ): {
            value: SummaryType['potentialGrowthCalls'] | null;
            delta: null;
        } => ({
            value: data?.potentialGrowthCalls || null,
            delta: null,
        }),
    },
    {
        langKey: 'REVIEWS_ANALYSIS__COMPETITORS__STATISTICS__GROWTH_POTENTIAL_TRAFFIC',
        formatOptions: {
            maximumFractionDigits: 0,
        },
        isInvertColor: false,
        getValueAndDelta: (
            data?: SummaryType
        ): {
            value: SummaryType['potentialGrowthWebsite'] | null;
            delta: null;
        } => ({
            value: data?.potentialGrowthWebsite || null,
            delta: null,
        }),
    },
];
